<template>
<div>
  <editor
    api-key="6s8agpscdhpz5jrgn43hwbrncq9icboi51103m0r2j5qkv1y"   
    output-format="html"
    :initial-value="value"        
    @input="updateValue" 
    v-model="content" 
    :disabled="disabled"
    :init="{
      height: 450,
      menubar: false,      
      branding: false,
      plugins: ['lists', 'paste'],
      paste_as_text: true,
      statusbar: false,
      toolbar: 'formatselect bold italic |  numlist bullist',
    }"
  />
</div>  
</template>
<script>
import Editor from "@tinymce/tinymce-vue";
export default {
    name:"tinymce",
    props: ['value','disabled']        
    ,
    data(){
        return{
            content:""
        }
        },
  
    // created(){
    //   console.log(this.value)
    // },
    methods:{
      updateValue (){
        this.$emit("input", this.content)
      }, 
      keyUp(){        
        this.$emit("validateCharacters")         
      }       
    },
    watch:{
      value:function(val){
        // console.log(val,this.content)
        this.content = val;
        this.$emit("validateCharacters")
      },
      content:function(val){
        this.$emit("validateCharacters")
      }
    },
    components: {   
    editor: Editor,
  },
};
</script>